import { render, staticRenderFns } from "./EcommerceTemplate.vue?vue&type=template&id=5567ebc2&"
import script from "./EcommerceTemplate.vue?vue&type=script&lang=js&"
export * from "./EcommerceTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports